/* eslint-disable import/extensions */
import { IdleQueue } from 'idlize/IdleQueue.mjs'
import Router from '@titanio/router'

const loader = () => {
  const queue = new IdleQueue()
  const router = new Router({
    pathname: window.location.pathname,
  })

  router.get('/recomendacao-de-credito/:permalink/', () => {
    import(
      /* webpackChunkName: "apply-page" */
      '@routes/apply'
    ).then((page) => {
      page.default.mount()
    })
  })

  router.get(
    [
      '/emprestimo/',
      '/contadigital/',
      '/cartaodecredito/',
    ],
    () => {
      import(
        /* webpackChunkName: "group-home-page" */
        '@routes/home'
      ).then((page) => {
        page.default.mount()
      })
    },
  )

  queue.pushTask(() => router.init())
}

export default { loader }
